import LS from '../helpers/localStorageHelper';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { languages } from 'src/common/constants';
import getLanguageFromLocation from 'src/common/helpers/getLanguageFromLocation';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import XHR from 'i18next-xhr-backend';
import version from 'bundle-text:../../static/translates/assets/version.txt';

const lng = getLanguageFromLocation();
const versions = languages.reduce(
    (acc, lang) => ({ ...acc, [lang]: version }),
    {},
);
console.log(lng, 'lng');

const getBackend = () => {
    const backend = {
        backends: [XHR],
        backendOptions: [
            {
                loadPath: ([lng]) =>
                    `${
                        process.env.CLIENT_PUBLIC_URL || ''
                    }/static/translates/assets/${lng}.json`,
            },
        ],
    };
    try {
        if (localStorage && typeof localStorage !== 'undefined') {
            backend.backends = [LocalStorageBackend, ...backend.backends];
            backend.backendOptions = [{ versions }, ...backend.backendOptions];
        }
    } catch (error) {
        console.log(error);
    }
    return backend;
};

const defaultProps = {
    backend: getBackend(),
    lng,
    languages,
    fallbackLng: 'en',
    // debug: true,
    ns: ['translations'],
    defaultNS: 'translations',
    nsSeparator: ':::',
    keySeparator: false,
    defaultValue: ' ',
    initImmediate: false,
    react: {
        wait: false,
        omitBoundRerender: true,
        bindI18n: 'languageChanged',
        bindStore: false,
        nsMode: 'translations',
        usePureComponent: true,
        useSuspense: false,
    },
    load: 'languageOnly',
    partialBundledLanguages: true,
    interpolation: {
        defaultVariables: {
            DOMAIN: '',
        },
    },
};

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        ...defaultProps,
    });

export default i18n;
